<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> FATURAS SPF - BACKUP </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <alert
        :type="typeAlert"
        :visible="showAlert"
        :message="messageAlert"
        :clickClose="() => (showAlert = false)"
      ></alert>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="3">
              <v-autocomplete
                :items="franchises"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="franchise"
                label="Franquia"
                hide-details
                clearable
                dense
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="months"
                v-model="month"
                label="Mês"
                hide-details
                dense
                clearable
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="years"
                v-model="year"
                label="Ano"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="disabledOptions"
                label="Retificada?"
                dense
                hide-details
                outlined
                v-model="disabled"
              ></v-select>
            </v-col>
            <v-col class="d-flex">
              <v-btn
                dark
                color="blue darken-3"
                small
                class="mt-2"
                @click="getInvoices()"
              >
                Executar Consulta
              </v-btn>
            </v-col>
            <!-- <v-col>
              <v-btn
                :disabled="items.length == 0"
                @click="exportReport('pdf')"
                color="grey darken-4"
                outlined
                small
                class="mt-3 mr-1 float-right"
              >
                <v-icon color="red" left> mdi-file-pdf-box </v-icon>
                PDF
              </v-btn>
            </v-col> -->
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-simple-table dense fixed-header height="380">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left fs-12 text-no-wrap"></th>
                              <th class="text-left fs-12 text-no-wrap">
                                Franqueado
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Documento
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Faturamento
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                Vr. Documento
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                Vr. Fatura
                              </th>
                              <th class="text-right fs-12 text-no-wrap">
                                Vr. Royalties
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="item in items"
                              :key="`${item.filial}${item.documento}`"
                            >
                              <td>
                                <v-btn
                                  :href="
                                    getUrlPrint(item.filial, item.documento)
                                  "
                                  class="pa-2"
                                  target="_blank"
                                  color="indigo"
                                >
                                  <v-icon color="white">mdi-printer</v-icon>
                                </v-btn>
                              </td>
                              <td>
                                {{ item.empresa.codigoSGA }} -
                                {{ item.empresa.nome }}
                              </td>
                              <td>{{ item.documento }}</td>
                              <td>{{ formatDate(item.faturamento) }}</td>
                              <td class="text-right fs-12 text-no-wrap">
                                {{ item.valdoc | currencyEuaToBr }}
                              </td>
                              <td class="text-right fs-12 text-no-wrap">
                                {{ item.valfat | currencyEuaToBr }}
                              </td>
                              <td class="text-right fs-12 text-no-wrap">
                                {{ item.valroy }}%
                              </td>
                            </tr>
                          </tbody>
                          <tfoot v-if="items.length > 0">
                            <tr>
                              <th colspan="7">
                                Total de Faturas:
                                {{ items.length }}
                              </th>
                            </tr>
                          </tfoot>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="400"
      v-model="linkDownload"
    >
      <v-card>
        <v-card-text class="pa-10">
          <v-btn
            class="ma-5 white--text justify-center d-flex"
            large
            color="indigo"
            target="_blank"
            :href="download.link"
            @click="() => (linkDownload = false)"
          >
            <v-icon left>mdi-cloud-download</v-icon>
            CLIQUE AQUI PARA BAIXAR
          </v-btn>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="linkDownload = false">
            FECHAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { URL } from "@/api/config";
import Alert from "@/components/Alert";
import * as CompanyAPI from "@/api/requests/CompanyRequest";

export default {
  components: { Alert },
  data: () => ({
    months: [
      { value: 1, text: "Janeiro" },
      { value: 2, text: "Fevereiro" },
      { value: 3, text: "Março" },
      { value: 4, text: "Abril" },
      { value: 5, text: "Maio" },
      { value: 6, text: "Junho" },
      { value: 7, text: "Julho" },
      { value: 8, text: "Agosto" },
      { value: 9, text: "Setembro" },
      { value: 10, text: "Outubro" },
      { value: 11, text: "Novembro" },
      { value: 12, text: "Dezembro" },
    ],
    month: "",
    years: [
      { value: 2023, text: "2023" },
      { value: 2022, text: "2022" },
      { value: 2021, text: "2021" },
    ],
    year: 2023,
    loading: false,
    showAlert: false,
    lazy: false,
    valid: true,
    typeAlert: "error",
    messageAlert: "",
    franchises: [],
    franchise: "",
    disabledOptions: [
      { value: 0, text: "Não" },
      { value: 1, text: "Sim" },
    ],
    image: 0,
    disabled: 1,
    launch: 0,
    items: [],
    linkDownload: false,
    download: {
      name: "",
      link: "#",
    },
  }),
  computed: {},
  created() {
    // let dateNow = new Date();
    // this.month = dateNow.getMonth() + 1;
    // this.year = dateNow.getFullYear();
    // let yearNow = dateNow.getFullYear();

    // // COLOCA 10 ANOS PARA TRAS
    // for (let i = 4; i > 0; i--) {
    //   this.years.push(yearNow - i);
    // }
    // this.years = this.years.reverse();
    this.initialize();
  },
  methods: {
    async initialize() {
      this.getCompanies();
    },
    validate() {},
    async getCompanies() {
      try {
        let res = await CompanyAPI.getAll();
        this.franchises = res
          .filter((item) => item.type === "fra")
          .sort((a, b) => (a.code < b.code ? -1 : 1));
      } catch (error) {
        console.log(error);
      }
    },
    async getInvoices() {
      this.showAlert = false;
      this.loading = true;
      this.items = [];
      let franchiseSelected = this.franchises.find(
        (item) => item.id === this.franchise
      );
      let data = {
        franchise_id: this.franchise,
        franchise_code: franchiseSelected.code,
        month: this.month,
        year: this.year,
        disabled: this.disabled,
      };
      try {
        let response = await fetch(`${URL}spf-backup/invoices`, {
          method: "POST",
          body: JSON.stringify(data),
          headers: new Headers({
            "Content-Type": "application/json",
          }),
        });
        let res = await response.json();
        console.log(res);
        this.items = res;
      } catch (error) {
        this.messageAlert =
          "Não foi possível carregar as, tente novamente mais tarde";
        this.typeAlert = "error";
        this.showAlert = true;
      } finally {
        this.loading = false;
      }
    },
    async exportReport(type) {
      this.download = {
        name: "",
        link: "#",
      };
      this.linkDownload = false;
      let data = {};
      data.items = this.items;
      this.loading = true;
      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let res = await fetch(`${URL}spf-backup/export/${type}`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        if (!res.ok) {
          throw new Error(res.message);
        }
        let response = await res.json();
        this.download.name = response.nome;
        this.download.link = `${URL}spf-backup/download/${response.nome}`;
        this.linkDownload = true;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    getUrlPrint(filial, documento) {
      return `${URL}spf-backup/print/${filial}/${documento}`;
    },
    formatDate(value) {
      if (!value) return "";
      let [date] = value.split(" ");
      date = date.split("-").reverse().join("/");
      return `${date}`;
    },
  },
};
</script>
<style scoped>
.v-data-table {
  overflow-x: auto;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11.5px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}
.v-data-table__wrapper table tfoot th {
  position: sticky;
  bottom: 0;
  background: #fff;
}
</style>
<style>
.text-area-uppercase textarea {
  text-transform: uppercase;
}
</style>
